










import { Vue, Component, Prop } from "@/shared/vuepack";
import EmployeeSearch from "@/shared/components/EmployeeSearch.vue";

@Component ({
    components: { EmployeeSearch }
})
export default class ConsumerDetail extends Vue {
  @Prop({required: false, default: null})
  routeToConsumerDetail: (username: string) => Location;
}
